import { useEffect, useState } from 'react'
import fetchLanguage from '../components/language/FetchLanguage'

const useChatTranslations = ({
  language,
}) => {
  const [translations, setTranslations] = useState(null)

  useEffect(() => {
    const loadTranslations = async () => {
      const data = await fetchLanguage('', language)

      setTranslations(data)
    }

    loadTranslations()
  }, [language])

  return {
    translations,
  }
}

export default useChatTranslations